<div
  class="fixed duration-500 transition-transform inset-x-0 bottom-0 z-50 flex flex-col items-center justify-center bg-gray-800 text-white p-4 sm:p-6 lg:p-8"
  [class.translate-y-full]="consentAsked()"
>
  @if (!showCustomSettings()) {
    <p class="md:text-lg text-center mb-4" i18n>
      We use cookies and other tracking technologies to analyze our website
      traffic and personalize ads.
    </p>
    <div
      class="flex flex-col md:flex-row gap-2 w-full max-w-3xl justify-center"
    >
      <button
        data-cy="accept-tracking"
        (click)="acceptAll()"
        class="bg-primary w-full md:w-auto min-w-[150px] hover:bg-primary-800 px-4 py-2 text-sm md:text-base font-semibold rounded-lg"
        i18n
      >
        Accept All
      </button>
      <button
        (click)="denyAll()"
        data-cy="deny-tracking"
        class="bg-gray-600 w-full md:w-auto min-w-[150px] hover:bg-gray-700 px-4 py-2 text-sm md:text-base font-semibold rounded-lg"
        i18n
      >
        Decline All
      </button>
      <button
        (click)="toggleCustomSettings()"
        data-cy="custom-tracking"
        class="bg-transparent border border-gray-500 w-full md:w-auto min-w-[150px] hover:bg-gray-700 px-4 py-2 text-sm md:text-base font-semibold rounded-lg"
        i18n
      >
        Custom
      </button>
    </div>
  } @else {
    <div class="w-full max-w-2xl">
      <p class="text-xl font-bold mb-4" i18n>Customize Tracking Preferences</p>

      <div class="flex flex-col gap-4 mb-6">
        <label class="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            [(ngModel)]="preferences.analytics_storage"
            class="w-5 h-5 accent-primary"
          />
          <span i18n>
            <strong>Analytics:</strong>
            Allows us to analyze website traffic and usage.
          </span>
        </label>

        <label class="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            [(ngModel)]="preferences.ad_storage"
            class="w-5 h-5 accent-primary"
          />
          <span i18n>
            <strong>Ad Storage:</strong>
            Enables storage (such as cookies) related to advertising.
          </span>
        </label>

        <label class="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            [(ngModel)]="preferences.ad_user_data"
            class="w-5 h-5 accent-primary"
          />
          <span i18n>
            <strong>Ad User Data:</strong>
            Sets consent for sending user data to Google for advertising
            purposes.
          </span>
        </label>

        <label class="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            [(ngModel)]="preferences.ad_personalization"
            class="w-5 h-5 accent-primary"
          />
          <span i18n>
            <strong>Ad Personalization:</strong>
            Sets consent for personalized advertising.
          </span>
        </label>
      </div>

      <div class="flex flex-col md:flex-row gap-2 justify-end">
        <button
          (click)="toggleCustomSettings()"
          class="bg-transparent border border-gray-500 hover:bg-gray-700 px-4 py-2 text-sm md:text-base font-semibold rounded-lg"
          i18n
        >
          Back
        </button>
        <button
          (click)="saveCustom()"
          data-cy="save-custom-tracking"
          class="bg-primary hover:bg-primary-800 px-4 py-2 text-sm md:text-base font-semibold rounded-lg"
          i18n
        >
          Save Preferences
        </button>
      </div>
    </div>
  }
</div>
